import Box from "@mui/material/Box";
import React from "react";
import {FormControl, FormHelperText} from "@mui/material";
import Typography from "@mui/material/Typography";
import {DatePicker} from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid/Grid";

export default (data, key) => {
    return (
        <Grid item md={12} xs={12} key={key} className={data.classList}>
            <FormControl fullWidth key={key} error={data.error ? true : false}>
                <Box fullWidth style={{padding: '10px 0'}}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Typography>
                            {data.headerName}
                        </Typography>
                        <DatePicker
                            key={key}
                            id={`${data.name}-${key}`}
                            name={data.name}
                            selected={data.value}
                            value={data.value}
                            renderInput={(params) => <TextField {...params} />}
                            onChange={(e) => {
                                data.onCallback({
                                    target: {
                                        name: data.name,
                                        value: e
                                    }
                                })
                            }}
                        />
                    </LocalizationProvider>
                    {data.error && (<FormHelperText>{data.error}</FormHelperText>)}
                </Box>
            </FormControl>
        </Grid>)
}

